export default "__VITE_PUBLIC_ASSET__3750c9ec__"